import React from 'react';

import { StyledTextArea } from './index.styles';

const NotesField = (props: React.TextareaHTMLAttributes<HTMLTextAreaElement>) =>
  (
    <StyledTextArea
      {...props}
    />
  );

export default NotesField;
